/**
 * Header Logo Scroll Animation
 * Logo scales down smoothly on scroll (always visible, just shrinks)
 */

(function () {
  'use strict';

  var logoScrollInstance = null;
  var SCROLL_END = 80;

  function destroyLogoScroll() {
    if (logoScrollInstance) {
      logoScrollInstance.revert();
      logoScrollInstance = null;
    }
  }

  function setupLogoScroll(heading) {
    if (!heading) {
      return function () {};
    }

    var logoTarget = heading.querySelector('.logo-svg-code');
    if (!logoTarget) {
      return function () {};
    }

    gsap.set(logoTarget, {
      scale: 1,
      transformOrigin: 'center center',
      force3D: true
    });

    var scrollEnd = parseInt(heading.getAttribute('data-scroll-end'), 10) || SCROLL_END;

    var tween = gsap.to(logoTarget, {
      scale: 0.75,
      ease: 'power1.inOut',
      immediateRender: false,
      scrollTrigger: {
        trigger: document.documentElement,
        start: 0,
        end: scrollEnd,
        scrub: 0.6,
        invalidateOnRefresh: true
      }
    });

    return function () {
      if (tween.scrollTrigger) {
        tween.scrollTrigger.kill();
      }

      tween.kill();
      gsap.set(logoTarget, { clearProps: 'transform' });
    };
  }

  function initHeaderLogoScroll() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
      console.log('[Logo Scroll] GSAP or ScrollTrigger not loaded yet');
      return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      console.log('[Logo Scroll] Reduced motion preference detected, skipping animation');
      return;
    }

    if (!document.querySelector('[data-header-logo-scroll]')) {
      console.log('[Logo Scroll] No [data-header-logo-scroll] element found');
      return;
    }

    console.log('[Logo Scroll] Initializing logo scroll animation');
    destroyLogoScroll();
    gsap.registerPlugin(ScrollTrigger);

    logoScrollInstance = gsap.matchMedia();

    logoScrollInstance.add('(min-width: 992px)', function () {
      console.log('[Logo Scroll] Setting up desktop animation');
      var cleanup = setupLogoScroll(
        document.querySelector('.header__heading.d-lg-flex[data-header-logo-scroll]')
      );

      ScrollTrigger.refresh();

      return cleanup;
    });

    logoScrollInstance.add('(max-width: 991px)', function () {
      console.log('[Logo Scroll] Setting up mobile animation');
      var cleanup = setupLogoScroll(
        document.querySelector('.logo-mobile [data-header-logo-scroll]')
      );

      ScrollTrigger.refresh();

      return cleanup;
    });
  }

  function waitForGsapAndInit() {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      initHeaderLogoScroll();
      return;
    }

    console.log('[Logo Scroll] Waiting for GSAP to load...');
    window.addEventListener('load', initHeaderLogoScroll, { once: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitForGsapAndInit);
  } else {
    waitForGsapAndInit();
  }

  document.addEventListener('shopify:section:load', waitForGsapAndInit);

  var resizeTimer;
  window.addEventListener(
    'resize',
    function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        initHeaderLogoScroll();
      }, 150);
    },
    { passive: true }
  );
})();
